import * as RadixDialog from '@radix-ui/react-dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { popoverContainers } from '../../core/popovers/popover-containers';
import { Icon } from '../icon/icon';
import { Typography } from '../typography/typography';
import styles from './dialog.module.scss';

type Props = {
  title: string;
  trigger: React.ReactNode;
  children: React.ReactNode;
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
};

export const Dialog: React.FC<Props> = ({ title, trigger, children, isOpen, onOpenChange }) => {
  const { t } = useTranslation();
  return (
    <RadixDialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <RadixDialog.Trigger asChild>{trigger}</RadixDialog.Trigger>
      <RadixDialog.Portal container={popoverContainers.general()}>
        <RadixDialog.Overlay className={styles.dialogOverlay} />
        <RadixDialog.Content aria-describedby={undefined} className={styles.root}>
          <div className={styles.titleContainer}>
            <RadixDialog.Title asChild>
              <Typography variant="headline-3">{title}</Typography>
            </RadixDialog.Title>
            <RadixDialog.Close asChild>
              <button aria-label={t('a11y.close')} className={styles.closeButton}>
                <Icon size="24" variant="cross" />
              </button>
            </RadixDialog.Close>
          </div>
          {children}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
